// extracted by mini-css-extract-plugin
export default {"wrap":"otherPage_wrap__Tx+BG","content":"otherPage_content__F8J4U","title":"otherPage_title__ukHVL","des":"otherPage_des__uXBdx"};